/* Homepage custom carousel controls. */
(() => {
  const init = (section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const track = section.querySelector('[data-home-carousel-track]');
    if (!track) return;
    const move = (direction) => {
      const amount = track.querySelector(':scope > *')?.getBoundingClientRect().width || track.clientWidth;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };
    section.querySelector('[data-home-carousel-prev]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-home-carousel-next]')?.addEventListener('click', () => move(1));
    if (section.dataset.autoplay === 'true') {
      const speed = Number(section.dataset.autoplaySpeed) || 5000;
      let timer = setInterval(() => move(1), speed);
      section.addEventListener('mouseenter', () => clearInterval(timer));
      section.addEventListener('mouseleave', () => { timer = setInterval(() => move(1), speed); });
    }
  };
  document.querySelectorAll('[data-home-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-home-carousel]').forEach(init));
})();
